let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9qNkk")).then(() => parcelRequire('6hL2q'));